import * as React from 'react';
import { useContext } from 'react';
import { AppContext } from '../school-search-app';
import { getAvailabilityColor } from '../../utility/api-utilities';
import { PAGE_MODE, SCHOOL_TYPE } from '../../interfaces'

export interface IResultList {
    school: any,
    onClick: () => void
    isCompareSchool: boolean;
    compareSchool: (any, boolean) => void,
    profileRedirectUrl: string | null
}

function ResultListEntry({ school, schoolInfo, focusMap, isCompareSchool, compareSchool, profileRedirectUrl }) {
    const duration = [school._epi.fullYear ? school._epi.fullYear : null, school._epi.schoolYear ? school._epi.schoolYear : null].filter(x => x != null).join(', ');
    const day = [school._epi.fullDayProgram ? school._epi.fullDayProgram : null, school._epi.partDayProgram ? school._epi.partDayProgram : null].filter(x => x != null).join(', ');
    const appContext = useContext(AppContext);
    const circleClass = `circle ${getAvailabilityColor(school._epi.availability)}`;
    const cpsPrek = (appContext.mode == PAGE_MODE.PREK && school.type == SCHOOL_TYPE.CPS);

    // ********** CPS *****
    if (appContext.mode === PAGE_MODE.GOCPS) {
        return (
            <tr className={`${school.type} ${school._tag && school._tag == 'Neighborhood School' ? 'neighborhood-school' : ''}`} data-schoolId={school._epi.id}>
                <td className="result-card-actions">
                    <label>
                        <input type="checkbox" checked={isCompareSchool} onChange={e => compareSchool(school, e.target.checked)} />
                    </label>
                </td>
                <td>
                    <div className="title">{school._tag && school._tag == 'Neighborhood School' ? <span className="neighborhood-icon" role="img" aria-label="Neighborhood school icon"></span> : ''}{school._epi.title}</div>
                    {/*<a onClick={() => onClick(school._epi.id)}>More Info</a>*/}
                    <div className="links">{profileRedirectUrl ?
                        <a href={'' + profileRedirectUrl + school._epi.id} target="_blank">More Info</a> :
                        <a onClick={() => schoolInfo(school._epi.id)}>More Info</a>
                    }
                        <a onClick={() => focusMap(school._epi.id)}>View On Map</a>
                    </div>
                </td>
                <td>
                    {school._epi.gradesOffered}
                </td>
                <td>
                    {school._epi.studentCount}
                </td>
                {/*    <td>*/}
                {/*        {school._epi.availability}*/}
                {/*    </td>*/}
            </tr>
        );
    }

    // ********** PREK *****
    return (
        <tr className={`${school.type}`} data-schoolId={school._epi.id}>
            <td className="result-card-actions">
                <label>
                    <input type="checkbox" checked={isCompareSchool} onChange={e => compareSchool(school, e.target.checked)} />
                </label>
            </td>
            <td>
                <div className="title">{school._tag && school._tag == 'Neighborhood School' ? <span className="neighborhood-icon" role="img" aria-label="Neighborhood school icon"></span> : ''}{school._epi.title}</div>
                {/*<a onClick={() => onClick(school._epi.id)}>More Info</a>*/}
                <div className="links">
                    <a onClick={() => schoolInfo(school._epi.id)}>More Info</a>
                    <a onClick={() => focusMap(school._epi.id)}>View On Map</a>
                </div>
            </td>
            <td>
                {cpsPrek ? 'CPS Based' : 'Community Based'}
            </td>
            <td>
                {cpsPrek ? 'School Year' : duration}
            </td>
            <td>
                {day}
            </td>
            <td>
                <span className={circleClass}></span> {school._epi.availability}
            </td>
        </tr>
    );
}

export default ResultListEntry;
